/**
 * Validators
 * Form validation utilities
 */

import { MESSAGE_LIMITS, FINANCIAL_LIMITS } from './constants';

export interface ValidationResult {
  valid: boolean;
  error?: string;
}

/**
 * Validate message message
 */
export const validateMessage = (message: string): ValidationResult => {
  if (!message || message.trim().length === 0) {
    return {
      valid: false,
      error: 'Le message ne peut pas être vide',
    };
  }

  if (message.length > MESSAGE_LIMITS.MAX_LENGTH) {
    return {
      valid: false,
      error: `Le message est trop long (maximum ${MESSAGE_LIMITS.MAX_LENGTH} caractères)`,
    };
  }

  return { valid: true };
};

/**
 * Validate financial amount
 */
export const validateAmount = (
  amount: number | undefined,
  fieldName: string = 'Montant'
): ValidationResult => {
  if (amount === undefined || amount === null) {
    return { valid: true }; // Optional field
  }

  if (amount < FINANCIAL_LIMITS.MIN_AMOUNT) {
    return {
      valid: false,
      error: `${fieldName} ne peut pas être négatif`,
    };
  }

  if (amount > FINANCIAL_LIMITS.MAX_AMOUNT) {
    return {
      valid: false,
      error: `${fieldName} est trop élevé`,
    };
  }

  return { valid: true };
};

/**
 * Validate age
 */
export const validateAge = (age: number | undefined): ValidationResult => {
  if (age === undefined || age === null) {
    return { valid: true }; // Optional field
  }

  if (age < FINANCIAL_LIMITS.MIN_AGE || age > FINANCIAL_LIMITS.MAX_AGE) {
    return {
      valid: false,
      error: `L'âge doit être entre ${FINANCIAL_LIMITS.MIN_AGE} et ${FINANCIAL_LIMITS.MAX_AGE} ans`,
    };
  }

  return { valid: true };
};

/**
 * Validate dependents
 */
export const validateDependents = (
  dependents: number | undefined
): ValidationResult => {
  if (dependents === undefined || dependents === null) {
    return { valid: true }; // Optional field
  }

  if (dependents < FINANCIAL_LIMITS.MIN_DEPENDENTS) {
    return {
      valid: false,
      error: 'Le nombre de personnes à charge ne peut pas être négatif',
    };
  }

  return { valid: true };
};

/**
 * Validate email
 */
export const validateEmail = (email: string): ValidationResult => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    return {
      valid: false,
      error: 'Adresse email invalide',
    };
  }
  return { valid: true };
};

/**
 * Validate password
 */
export const validatePassword = (password: string): ValidationResult => {
  if (!password || password.length < 6) {
    return {
      valid: false,
      error: 'Le mot de passe doit contenir au moins 6 caractères',
    };
  }
  return { valid: true };
};

